// extracted by mini-css-extract-plugin
var _1 = "DqMzkJTrAYZKX3ppwBAu";
var _2 = "DqMzkJTrAYZKX3ppwBAu";
var _3 = "F3wSGspkhXGx3RZc5vYF";
var _4 = "F3wSGspkhXGx3RZc5vYF";
var _5 = "bLEQOKiNVbe4bppSVUiS";
var _6 = "bLEQOKiNVbe4bppSVUiS";
var _7 = "dqEvXh7YQf67wMeHddZV";
var _8 = "dqEvXh7YQf67wMeHddZV";
var _9 = "DQizySgqWgwFdl3b_ipG";
var _a = "aMZYZIjgB0pSFBHNC1vk";
export { _1 as "bottom-element", _2 as "bottomElement", _3 as "field-was-modified", _4 as "fieldWasModified", _5 as "group-element", _6 as "groupElement", _7 as "margin-bottom", _8 as "marginBottom", _9 as "minimum", _a as "title" }
